import createToolbar from './toolbar/createToolbar.js';
import { Component as GiphyComponent } from './giphy-component.js';
import { GIPHY_TYPE } from './types.js';
import { createBasePlugin } from 'wix-rich-content-plugin-commons';
import { DEFAULTS } from './constants.js';
import './toolbar/inline-buttons.js';
import 'wix-rich-content-editor-common';
import './toolbar/giphyInsertModal.js';
import 'react';
import './giphyApiInputModal-d33234ba.js';
import 'prop-types';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import './style-inject.es-746bb8ed.js';
import './toolbar/giphySelector.js';
import 'react-infinite-scroller';
import 'react-md-spinner';
import 'react-custom-scrollbars';
import './giphyEmptyState-908a0922.js';
import './icons/PoweredByGiphy.js';
import 'classnames';
import 'lodash';
import './icons/MediaReplaceIcon.js';
import './toolbar/insert-buttons.js';
import './icons/InsertPluginIcon.js';
import './giphy-viewer.js';
import 'wix-rich-content-common/dist/statics/schemas/plugin-giphy.schema.json';
import './giphy-viewer-e3f57a06.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __restKey = (key) => typeof key === "symbol" ? key : key + "";
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const createGiphyPlugin = (config) => {
  const type = GIPHY_TYPE;
  const _a = config, { helpers, t, [type]: settings = {}, isMobile } = _a, rest = __objRest(_a, ["helpers", "t", __restKey(type), "isMobile"]);
  return createBasePlugin(__spreadValues({
    component: GiphyComponent,
    type: GIPHY_TYPE,
    toolbar: createToolbar({
      helpers,
      t,
      settings,
      isMobile
    }),
    helpers,
    settings,
    t,
    isMobile,
    defaultPluginData: DEFAULTS
  }, rest));
};
createGiphyPlugin.functionName = GIPHY_TYPE;

export { createGiphyPlugin };
//# sourceMappingURL=createGiphyPlugin.js.map
